import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const services = [
  { name: "Lawn Care", path: "/services/lawn-care" },
  { name: "Aeration & Overseeding", path: "/services/aeration" },
  { name: "Mulching & Beds", path: "/services/mulching" },
  { name: "Dethatching", path: "/services/dethatching" },
  { name: "Spring & Fall Cleanups", path: "/services/spring-fall-cleanups" },
  { name: "Snow Removal", path: "/services/snow-removal" },
];

export const ServiceSidebar = () => {
  const location = useLocation();

  return (
    <aside className="lg:sticky lg:top-28 space-y-6">
      <div className="bg-card rounded-2xl border border-border p-6">
        <h3 className="text-lg font-heading font-bold text-foreground mb-4">Our Services</h3>
        <nav className="space-y-2">
          {services.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className={`service-sidebar-link ${
                location.pathname === service.path ? "active" : ""
              }`}
            >
              {service.name}
            </Link>
          ))}
        </nav>
      </div>

      <div className="bg-secondary rounded-2xl p-6 text-secondary-foreground">
        <h3 className="text-lg font-heading font-bold mb-3">Need Help?</h3>
        <p className="text-secondary-foreground/80 mb-4 text-sm">
          Our team is ready to assist you with any lawn care or landscaping project.
        </p>
        <a href="tel:+17632457813">
          <Button
            variant="secondary"
            className="w-full bg-white hover:bg-white/90 text-secondary font-semibold"
          >
            <Phone className="w-4 h-4 mr-2" /> Call Now
          </Button>
        </a>
        <Link to="/contact" className="block mt-3">
          <Button
            variant="outline"
            className="w-full border-secondary-foreground bg-secondary-foreground text-secondary hover:bg-secondary-foreground/90 font-semibold"
          >
            Get a Free Quote <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </aside>
  );
};
